import React, { ReactElement, SVGProps } from 'react'
import BaseIcon from "./BaseIcon";

export default function WalletIcon(props: SVGProps<any>): ReactElement {
  return (
    <BaseIcon {...props} viewBox="0 0 31 31">
      <path
        d="M6.75 27.5a2.4 2.4 0 0 1-1.766-.734A2.4 2.4 0 0 1 4.25 25V7.5q0-1.03.734-1.766A2.4 2.4 0 0 1 6.75 5h17.5q1.032 0 1.766.734.734.735.734 1.766h-10q-2.219 0-3.61 1.39-1.39 1.391-1.39 3.61V20q0 2.219 1.39 3.61Q14.532 25 16.75 25h10q0 1.032-.734 1.766t-1.766.734zm10-5a2.4 2.4 0 0 1-1.766-.734A2.4 2.4 0 0 1 14.25 20v-7.5q0-1.03.734-1.766A2.4 2.4 0 0 1 16.75 10h8.75q1.032 0 1.766.734Q28 11.47 28 12.5V20q0 1.032-.734 1.766T25.5 22.5zm3.75-4.375q.813 0 1.344-.531t.531-1.344-.531-1.344-1.344-.531-1.344.531-.531 1.344.531 1.344 1.344.531"
        fill="currentColor"
      />
    </BaseIcon>
  )
}
